import type { ReactNode } from "react";

export function DataTable({
  headings,
  children,
  className = ""
}: {
  headings: string[];
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`table-scroll ${className}`}>
      <table>
        <thead>
          <tr>
            {headings.map((heading) => (
              <th key={heading}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
